import Clickable from 'components/Common/Clickable'
import ModalContext from 'contexts/ModalContext'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import React, { MouseEventHandler, useCallback, useContext } from 'react'
import LoyaltyStayUpgradeBenefitModal from './LoyaltyStayUpgradeBenefitModal'
import LoyaltyTierBenefitPill from './LoyaltyTierBenefitPill'
import offerPageURL from 'lib/offer/offerPageURL'

interface Props {
  offer: App.HotelOffer | App.HotelOfferSummary
  hideViewOfferCta?: boolean
}

function LoyaltyStayUpgradeBenefitPill({ offer, hideViewOfferCta = false }: Props) {
  const tier = useAppSelector(getLoyaltyDisplayTier)
  const showModal = useContext(ModalContext)
  const offerUrl = offerPageURL(offer)

  const showRoomUpgradesModal = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    showModal(<LoyaltyStayUpgradeBenefitModal offer={offer} offerUrl={hideViewOfferCta ? undefined : offerUrl} />)
  }, [showModal, offer, offerUrl, hideViewOfferCta])

  return <Clickable onClick={showRoomUpgradesModal}>
    <LoyaltyTierBenefitPill
      kind="secondary"
      tier={tier}
      benefitType="hotel_upgrade"
      endIcon={<LineInfoCircleIcon />}
    >
      Upgrade your stay free
    </LoyaltyTierBenefitPill>
  </Clickable>
}

export default withMountGuard(() => {
  return useAppSelector(getIsCurrentRegionUserLoyaltyRegion)
})(LoyaltyStayUpgradeBenefitPill)
